'use strict';

module.exports = {
    submitShareList: function () {
        $('body').on('click', '.js-share-wishlist-submit', function (e) {
            e.preventDefault();

            var url = $(this).data('action');

            var shareListReceiverField = $('.share-list-receiver-field');
            var wishlistID = shareListReceiverField.data('wishlist-id');

            $.spinner().start();

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'html',
                data: {
                    shareListReceiver: shareListReceiverField.val(),
                    wishlistID: wishlistID
                },
                success: function () {
                    $('.shareWishlistModal').modal('hide');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    makePublicList: function () {
        $('body').on('click', '.js-share-public-wishlist', function () {
            var url = $(this).data('url');
            var publicList = $(this).data('public');

            if (!publicList) {
                $.spinner().start();

                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    success: function () {
                        $.spinner().stop();
                    },
                    error: function () {
                        // Show notification
                        var $errorElement = $('.js-sharewishlist-public-error');
                        var textContent = $errorElement.data('textcontent');
                        $errorElement.text(textContent);

                        $.spinner().stop();
                    }
                });
            }
        });
    }
};
